import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, SharedActions } from '../../../Store'

export const useProfessores = (perfil: string) => {
  const dispatch = useDispatch()
  const professores = useSelector((state: RootState) => state.Shared.professores)
  const eventos = useSelector((state: RootState) => state.Shared.evento)
  const avaliacoesRelatorioFinal = useSelector((state: RootState) => state.Shared.avaliacaoRelatorioFinal)
  const avaliacoesRelatorioFinalApiState = useSelector((state: RootState) => state.Shared.apiStates.avaliacoesRelatoriosFinaisAction)
  const avaliacoesOficinaDebate = useSelector((state: RootState) => state.Shared.avaliacaoOficinaDebate)
  const avaliacoesOficinaDebateApiState = useSelector((state: RootState) => state.Shared.apiStates.oficinaDebateAction)
  const avaliacoesEncontroJuridico = useSelector((state: RootState) => state.Shared.avaliacaoEncontroJuridico)
  const avaliacoesEncontroJuridicoApiState = useSelector((state: RootState) => state.Shared.apiStates.encontroJuridicoAction)
  const relatoriosParciais = useSelector((state: RootState) => state.Shared.relatoriosParciais)
  const relatoriosParciaisApiState = useSelector((state: RootState) => state.Shared.apiStates.relatoriosParciaisAction)
  const relatoriosFinais = useSelector((state: RootState) => state.Shared.relatoriosFinais)
  const relatoriosFinaisApiState = useSelector((state: RootState) => state.Shared.apiStates.relatoriosFinaisAction)
  const eventosApiState = useSelector((state: RootState) => state.Shared.apiStates.eventoAction)
  const orientacoes = useSelector((state: RootState) => state.Shared.orientacoes)
  const professorAvaliarOficinaDebateApiState = useSelector((state: RootState) => state.Shared.apiStates.professorAvaliarOficinaDebateAction)
  const professorAvaliarEncontroJuridicoApiState = useSelector((state: RootState) => state.Shared.apiStates.professorAvaliarEncontroJuridicoAction)
  const professorAvalicaoesApiState = useSelector(
    (state: RootState) => state.Shared.apiStates.professoreAvalicaoesAction
  )
  const professorAvalicaoes = useSelector((state: RootState) => state.Shared.professorAvaliacoes)

  const professoresAtivos = useSelector((state: RootState) => state.Shared.professoresAtivos)

  const getProfessoresApiState = useSelector((state: RootState) => state.Shared.apiStates.updateProfessoresAction)

  const updateAvaliacaoRelatorioFinal = () => {
    dispatch(SharedActions.avaliacoesRelatoriosFinaisAction(perfil))
  }

  const updateAvaliacaoOficinaDebate = () => {
    if(perfil !== 'funcionario') dispatch(SharedActions.oficinaDebateAction(perfil))
  }

  const updateAvaliacaoEncontroJuridico = () => {
    if(perfil !== 'funcionario') dispatch(SharedActions.encontroJuridicoAction(perfil))
  }

  const updateProfessorList = () => {
    dispatch(SharedActions.updateProfessoresAction(perfil))
  }

  const updateRelatorioParcial = () => {
    dispatch(SharedActions.relatoriosParciaisAction(perfil))
  }

  const updateRelatorioFinal = () => {
    dispatch(SharedActions.relatoriosFinaisAction(perfil))
  }

  const professorAvaliarOficinaDebate = (avaliacao?: any, id?: any) => {
    dispatch(SharedActions.professorAvaliarOficinaDebateAction(avaliacao, id))
  }

  const professorAvaliarEncontroJuridico = (avaliacao?: any, id?: any) => {
    dispatch(SharedActions.professorAvaliarEncontroJuridicoAction(avaliacao, id))
  }

  if (perfil !== 'orientador') {
    React.useEffect(() => {
      updateAvaliacaoOficinaDebate()
      updateAvaliacaoEncontroJuridico()
      updateAvaliacaoRelatorioFinal()
      dispatch(SharedActions.eventoAction())
      dispatch(SharedActions.updateProfessoresAction(perfil))
      dispatch(SharedActions.professoreAvalicaoesAction(perfil))
      dispatch(SharedActions.professoresAtivosAction(perfil))
      dispatch(SharedActions.relatoriosParciaisAction(perfil))
      if(perfil !== 'funcionario') dispatch(SharedActions.oficinaDebateAction(perfil))
      if(perfil !== 'funcionario') dispatch(SharedActions.encontroJuridicoAction(perfil))
      dispatch(SharedActions.relatoriosFinaisAction(perfil))
    }, [dispatch, perfil])
  } else {
    React.useEffect(() => {
      updateAvaliacaoOficinaDebate()
      updateAvaliacaoEncontroJuridico()
      updateAvaliacaoRelatorioFinal()
      dispatch(SharedActions.relatoriosParciaisAction(perfil))
      dispatch(SharedActions.orientacoesAction(perfil))
      dispatch(SharedActions.relatoriosFinaisAction(perfil))
      dispatch(SharedActions.oficinaDebateAction(perfil))
      dispatch(SharedActions.encontroJuridicoAction(perfil))
      dispatch(SharedActions.eventoAction())
      dispatch(SharedActions.avaliacoesRelatoriosFinaisAction(perfil))
    }, [dispatch])
  }

  return {
    eventos,
    eventosApiState,
    updateAvaliacaoOficinaDebate,
    updateAvaliacaoEncontroJuridico,
    avaliacoesOficinaDebateApiState,
    avaliacoesOficinaDebate,
    avaliacoesRelatorioFinal,
    avaliacoesRelatorioFinalApiState,
    avaliacoesEncontroJuridicoApiState,
    avaliacoesEncontroJuridico,
    professores,
    relatoriosParciais,
    orientacoes,
    relatoriosFinais,
    getProfessoresApiState,
    updateRelatorioParcial,
    updateAvaliacaoRelatorioFinal,
    updateRelatorioFinal,
    updateProfessorList,
    professorAvaliarOficinaDebate,
    professorAvaliarEncontroJuridico,
    professorAvaliarOficinaDebateApiState,
    professorAvaliarEncontroJuridicoApiState,
    professorAvalicaoes,
    professoresAtivos,
    professorAvalicaoesApiState,
    relatoriosParciaisApiState,
    relatoriosFinaisApiState
  }
}
